import React from "react";
import priceListPdf from "../assets/Slimline Price List WEF August 2026.pdf";

function PriceList() {
  return (
    <div className="price-list-page">

      {/* Buttons */}
      <div className="price-list-buttons">
        <a
          href={priceListPdf}
          target="_blank"
          rel="noopener noreferrer"
          className="price-list-view-btn"
        >
          View Price List
        </a>

        <a
          href={priceListPdf}
          download="Slimline-Price-List-August-2026.pdf"
          className="price-list-download-btn"
        >
          Download Price List
        </a>
      </div>

      {/* PDF */}
      <div className="price-list-pdf">
        <iframe
          src={priceListPdf}
          title="Slimline Price List WEF August 2026"
        />
      </div>

    </div>
  );
}

export default PriceList;